<template>
<div class="btn-group">
    <button type="button" class="btn btn-light dropdown-toggle legitRipple" data-toggle="dropdown" aria-expanded="false" :disabled="disabled">{{ title }}</button>
    <div class="dropdown-menu dropdown-menu-left" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(123px, 38px, 0px);">
        <slot/>
    </div>
</div>
</template>
<script>
export default {
    name: "ButtonDropdown",
    props: {
        title: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>